// Minimal cookie helpers + consent gate. Structure ready for future 3rd-party cookies.

export function setCookie(name, value, days = 180) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax${secure}`;
}

export function getCookie(name) {
  const match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return match ? decodeURIComponent(match[1]) : null;
}

export function deleteCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}

export const CONSENT_COOKIE = "nd_cookie_consent";

// Read the current consent: "accepted" | "rejected" | null (not decided yet)
export function getConsent() {
  return getCookie(CONSENT_COOKIE);
}

export function setConsent(value) {
  setCookie(CONSENT_COOKIE, value, 180);
}

// Future 3rd-party scripts should call this before setting non-essential cookies.
export function hasConsent() {
  return getConsent() === "accepted";
}

export const OPEN_COOKIE_EVENT = "open-cookie-banner";

// Re-open the cookie banner so the user can change their decision.
export function openCookieSettings() {
  window.dispatchEvent(new Event(OPEN_COOKIE_EVENT));
}
